var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "__TEMP__SVG__",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19.038,
    viewBox: "0 0 24 19.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    d: "M32,7.726a3.314,3.314,0,0,0-6.16-1.694v0c-.028.046-.054.094-.08.142l-.013.025c-.022.041-.042.082-.062.124l-.018.039c-.017.038-.034.076-.049.115l-.019.048c-.014.036-.027.072-.04.109l-.018.055c-.011.035-.022.071-.032.107-.006.02-.012.04-.017.06s-.018.07-.026.1-.01.043-.015.063-.014.071-.02.1-.008.043-.012.065-.01.073-.015.11c0,.021-.006.043-.008.064,0,.04-.007.079-.01.12,0,.018,0,.038,0,.056,0,.059-.005.118-.005.178s0,.1,0,.152v.033q0,.073.011.146l0,.025c0,.044.01.088.016.13a.07.07,0,0,0,0,.027c.007.047.016.093.025.141a.2.2,0,0,0,.007.034c.01.044.02.089.031.133v.01c.012.046.025.091.039.136l.011.035c.014.044.029.087.044.129,0,.01.007.018.01.028.014.037.029.074.043.11,0,.011.008.021.013.032.018.041.036.082.055.122l.017.035c.018.036.036.072.055.108a3.328,3.328,0,0,0,1.145,1.231,3.218,3.218,0,0,0,.394.215l.02.01q.138.062.281.112l.049.016.077.024.071.02.1.026.09.021.06.012.095.017.049.008c.046.007.093.013.141.018l.04,0,.114.008.044,0c.051,0,.1,0,.151,0s.119,0,.178-.005l.056,0,.12-.01.065-.008.109-.015.065-.012.1-.02.063-.015c.035-.008.071-.016.1-.026l.06-.017.107-.032.055-.018.109-.04.048-.019c.039-.015.077-.032.115-.049l.039-.018c.042-.02.083-.04.124-.062l.025-.013c.048-.026.095-.051.142-.08h0a3.338,3.338,0,0,0,.8-.658A3.3,3.3,0,0,0,32,7.726Z",
    transform: "translate(-7.999 -4.411)",
    fill: "#5c3cef",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    d: "M19.761,11.855,14.3,16.1a.828.828,0,0,1-1.016,0L5.837,10.308A.828.828,0,1,1,6.853,9l6.94,5.4,4.874-3.79a4.958,4.958,0,0,1-.073-5.093H5.1a2.9,2.9,0,0,0-2.9,2.9V20.828a2.9,2.9,0,0,0,2.9,2.9H22.483a2.9,2.9,0,0,0,2.9-2.9V12.3a4.957,4.957,0,0,1-5.618-.448Z",
    transform: "translate(-2.207 -4.687)",
    fill: "#5c3cef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirMessage);
export default __webpack_public_path__ + "static/media/cir_message.4d501a80fd3e8ebf6e5f10d816e8715f.svg";
export { ForwardRef as ReactComponent };